import { createAction, props } from '@ngrx/store';

export const mCommitmentsViewPrimeContractComponentActions = {
  loadPage: createAction(
    '[Manager - Commitments View Prime Contract Component] Load Page',
    props<{ primeContractId: number }>(),
  ),
};
